module.exports = __webpack_public_path__ + "img/流体力学4_1_4.3dba574f.jpg";